import axios from 'axios';
import { BASEURL } from 'consts';

/* Instância do axios configurada com a URL base da API e envio de cookies (withCredentials) */
const api = axios.create({
  baseURL: BASEURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json; charset=utf-8'
  }
});

/* Anexa o access token (Bearer) em toda requisição, quando disponível */
api.interceptors.request.use((config) => {
  const accessToken = sessionStorage.getItem('sisare_access_token');

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
}, (error) => Promise.reject(error));

let refreshPromise = null;

/* Em caso de 401, tenta renovar o access token via refresh token e refaz a requisição original */
api.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;
  const status = error.response?.status;

  const isLoginRequest = originalRequest?.url?.includes('/login');
  const isRefreshRequest = originalRequest?.url?.includes('/refresh-token');

  if (
    status !== 401 ||
    !originalRequest ||
    originalRequest._retry ||
    isLoginRequest ||
    isRefreshRequest
  ) {
    return Promise.reject(error);
  }

  originalRequest._retry = true;

  try {
    if (!refreshPromise) {
      refreshPromise = api.post('/refresh-token').then((response) => {
        const newAccessToken = response.data?.accessToken;

        if (!newAccessToken) {
          throw new Error('Novo access token não retornado!');
        }

        sessionStorage.setItem('sisare_access_token', newAccessToken);

        return newAccessToken;
      }).finally(() => {
        refreshPromise = null;
      });
    }

    const newAccessToken = await refreshPromise;

    originalRequest.headers = originalRequest.headers || {};
    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

    return api(originalRequest);
  } catch (refreshError) {
    sessionStorage.removeItem('sisare_access_token');
    sessionStorage.removeItem('codUser');
    sessionStorage.removeItem('usuario');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('lastLogin');
    sessionStorage.removeItem('isTechnicalUser');

    return Promise.reject(refreshError);
  }
});

export default api;